import angular from 'angular'

export class DynamicChartDirective {
 static selector = 'dynamicCharts'
 static chartService($compile) {
  //Usage: <element dynamic-component='componentSelector'></element>

  var directive = {
   restrict: 'A',
   transclude: false,
   replace: false,
   link: link,
   scope: {
    props: '<',
    dyn: '<',
    pag: '<',
    csv: '=',
   },
  }

  return directive

  function link(scope, element, attrs) {
   scope.$watch(scope.dyn, function(newValue, oldValue) {
    element.html(`<${scope.dyn}
          trigger-update="props.triggerUpdate"
          viz-data="props.vizData"
          vis-title="props.properties.visTitle"
          size="props.size"
          is-loading="props.isLoading"
          is-error="props.isError"
          date-range="props.dateRange"
          properties="props"
          csv-export-properties="props.csvExportProperties"
          location-type="$ctrl.locationType"
          visualization-meta-data="props.visualizationMetaData">
          </${scope.dyn}>`)
    $compile(element.contents())(scope)
   })
  }
 }
}
